export const ImagotipoSellersControl = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 35 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.75 20.9566L14.1217 8.5L20.2329 14.6503L31.4971 3.30591" stroke="#183555" strokeWidth="3" strokeMiterlimit="10" strokeLinecap="round" />
            <path d="M25.1504 1.54346H33.2499V9.69859" stroke="#183555" strokeWidth="3" strokeMiterlimit="10" />
        </svg>
    )
}